import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Vad är ett egenkontrollprogram?";
const SHORT_ANSWER = "Ett dokument som beskriver hur du som tillståndshavare säkrar att alkohollagen följs i den dagliga driften – ålderskontroll, ordning, marknadsföring, bokföring.";

export const Route = createFileRoute("/fraga/vad-ar-egenkontrollprogram")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Vad är ett egenkontrollprogram" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Programmet ska finnas tillgängligt på serveringsstället. Vid tillsyn frågar kommunen ofta efter det. Saknas det dokumenterade rutiner är det en grund för anmärkning."}
      source={{ label: "Folkhälsomyndigheten – Serveringstillstånd (vägledning)", href: "https://www.folkhalsomyndigheten.se/livsvillkor-levnadsvanor/alkohol-narkotika-dopning-tobak-och-spel-andts/tillsynsvagledning-enligt-alkohollagen/serveringstillstand/" }}
      extraSources={[]}
      deepGuide={{ to: "/serveringstillstand", label: "Egenkontroll och tillsynsförberedelse" }}
      related={[{"to": "/fraga/vilka-anteckningar-maste-jag-fora", "label": "Vilka anteckningar måste jag föra i verksamheten?"}, {"to": "/fraga/vad-galler-vid-personalfest", "label": "Får jag servera alkohol på personalfest utan extra tillstånd?"}, {"to": "/fraga/far-jag-anvanda-personalrabatt", "label": "Får personalen få alkohol gratis eller till rabatt?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Vad är ett egenkontrollprogram?" },
      { name: "description", content: "Ett dokument som beskriver hur du som tillståndshavare säkrar att alkohollagen följs i den dagliga driften – ålderskontroll, ordning, marknadsföring, bokföring." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/vad-ar-egenkontrollprogram" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/vad-ar-egenkontrollprogram" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/vad-ar-egenkontrollprogram",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Vad är ett egenkontrollprogram", url: "https://alkoholprovet.se/fraga/vad-ar-egenkontrollprogram" },
      ]),
    ],
  }),
});
